<template>
  <section>
    <nav-component />
    <div class="container">
      <div class="common-path">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>登陆</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="register-box">
        <div class="register-li clearfix">
          <div class="register-li-text">
            <span class="text-red">*</span> 手机号码：
          </div>
          <div class="register-li-input">
            <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
          </div>
        </div>
        <div class="register-li clearfix">
          <div class="register-li-text">
            <span class="text-red">*</span> 密码：
          </div>
          <div class="register-li-input">
            <el-input v-model="form.password" placeholder="请输入密码" type="password"></el-input>
          </div>
        </div>
        <div class="register-li clearfix" v-if="false">
          <div class="register-li-text">
            <span class="text-red">*</span> 验证码：
          </div>
          <div class="register-li-input text-code">
            <el-input v-model="form.code" placeholder="验证码"></el-input>
          </div>
        </div>
        <div class="login-foot-box">
          <router-link to="/register" class="btn-reg">注册</router-link>
          <router-link to="/reset">忘记了密码</router-link>
        </div>
        <div class="register-btn-box">
          <el-button class="btn-register-submit" @click="onLogin" >登陆</el-button>
        </div>
      </div>
    </div>
    <!-- <div class="login-box">
      <div class="container">
        login
      </div>
    </div> -->
    <footer-component />
  </section>
</template>

<script>
import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import { mapActions } from 'vuex'
import commonMixin from '@/mixin/common'
export default {
  name: 'IndexPage',
  data () {
    return {
      form: {
        phone: null,
        password: null,
        code: null
      },
      loading: false
    }
  },
  mixins: [commonMixin],
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent
  },
  methods: {
    ...mapActions ({
      USER_LOGIN: 'USER_LOGIN'
    }),
    onLogin () {
      let phone = this.form.phone
      let password = this.form.password
      if (!phone) {
        this.error('请正确填写手机号')
        return false
      }
      if (!password) {
        this.error('请正确填写密码')
        return false
      }
      let data = {
        phone: this.form.phone,
        password: this.form.password,
      }
      this.loading = true
      this.USER_LOGIN(data).then(res => {
        this.loading = false
        this.success('登陆成功')
        this.$router.push({name: 'user'})
      }).catch(err => {
        this.loading = false
        try {
          this.error(err.message)
        } catch (e) {
          this.error(e.message)
        }
      })
    },
    reset () {
      this.form = {
        phone: null,
        password: null,
        code: null
      }
      this.loading = false
    },
    handleRoute (route) {
      if (route.name === 'login') {
        this.reset()
      }
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}
</script>
